import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {triviaList_template} from "../components/templates/triviaList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class trivia_list extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected triviaList: triviaList_template;
    protected pagination: pagination_template;

    buildContent(): Array<Element> {
        this.triviaList = new triviaList_template("triviaList", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Daily Trivia");
        return [this.triviaList.build()];
    }

    protected getModuleName(): string {
        return "trivia_list";
    }

    fillPage() {
        this.filterList();
        this.getSidebar();
    }

    protected paginationOnPageClick() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.filterList();
    }

    protected filterSimpleOnChange() {
        this.viewModel.triviaList.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
    }

    protected triviaListReorder() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.filterList();
    }

    protected filterList() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.triviaList.builtTemplate.children.namedItem("list-results"));

        let url: string = '/api/brand/' + this.getBrandId() + '/trivia/get/';
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.triviaList.getViewModelForRequest())]);

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                obj.triviaList.setTriviaItems(responseParsed.data, obj.getBrandId());

                let execTime = Math.round((new Date().getTime() - obj.XHRHdl.requestStartTime) / 1000 * 100) / 100;
                obj.triviaList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage, execTime);

                obj.viewModel.triviaList.pagination.itemCount(responseParsed.totalCount);
            });
            obj.loadingOut(obj.triviaList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected getSidebar() {
        let url: string = '/api/brand/' + this.getBrandId() + '/trivia/sidebar/get/';
        let sidebarHdl  = new XMLHttpRequestHandler(url, [], this);
        sidebarHdl.onReadyStateFunction = this.onGetSidebarReturn;
        sidebarHdl.execute();
    }

    protected onGetSidebarReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.triviaList.setSidebarData(responseParsed.data);
            });
        }
    }

    public saveSidebar(sidebarData) {
        this.loadingIn(this.triviaList.builtTemplate.children.namedItem("sidebar-section"));

        let url: string = '/api/brand/' + this.getBrandId() + '/trivia/sidebar/save/';
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(sidebarData)]);

        let XHRHdl = new XMLHttpRequestHandler(url, params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {
            return function () {
                obj.manageResponse(req, obj, function () {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Sidebar saved!');
                });
                obj.loadingOut(obj.triviaList.builtTemplate.children.namedItem("sidebar-section"));
            }
        });
        XHRHdl.execute();
    }

    public exportTrivia(month: string) {
        let url: string = '/api/brand/' + this.getBrandId() + '/trivia/export/';
        let params: Array<Array<string>> = [];
        params.push(["data", JSON.stringify({ month: month })]);

        let XHRHdl = new XMLHttpRequestHandler(url, params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {
            return function () {
                if (req.request.status === 200) {
                    const blob = new Blob([req.request.response], { type: 'text/csv' });
                    const a    = document.createElement('a');
                    a.href     = URL.createObjectURL(blob);
                    a.download = 'daily-trivia-user-correct-answers-' + month + '.csv';
                    a.click();
                }
            }
        });
        XHRHdl.execute();
    }

    protected viewTrivia(id) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        page('/brand/' + this.getBrandId() + '/trivia-lists/edit/' + id);
    }

    protected addTrivia() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        page('/brand/' + this.getBrandId() + '/trivia-lists/add/');
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }
}



// WEBPACK FOOTER //
// ./js/modules/trivia_list.ts